import React, { Component } from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { has } from 'lodash';

import { HHFileUploader, HHMultipleSelect, HHCheckbox, HHSingleSelect } from './fields';
import { FORM_NAME } from '../forms/formConstant';
import { ALERT_TYPE } from '../common/constant';
import { HHAlert } from '../common/util';
import {
  analyzeResumeScore,
  fetchUserProfile,
  fetchTags,
  updateUserProfile,
  redirectToLastViewedEssentialPage,
  sendNewSignUpEmail
} from '../actions';

// TODO validate username if existed
const formikEnhancer = withFormik({
  validationSchema: ({ translate }) =>
    Yup.object().shape({
      resumeUrl: Yup.string().url(translate('form.error.string.url')),
      isJobSeeking: Yup.boolean().required(translate('form.error.mixed.required')),
      education: Yup.string().required(translate('form.error.mixed.required')),
      profession: Yup.string().required(translate('form.error.mixed.required')),
      tags: Yup.array()
        .min(1, translate('form.error.array.min'))
        .max(5, translate('form.error.array.max'))
        .of(
          Yup.object().shape({
            label: Yup.string().required(),
            value: Yup.string().required()
          })
        )
    }),
  mapPropsToValues: () => ({
    resumeUrl: '',
    isJobSeeking: false,
    education: '',
    profession: '',
    tags: []
  }),
  handleSubmit: (values, { props, setSubmitting }) => {
    const submittedValues = {
      ...values,
      tags: values.tags.map(tag => tag.value),
      education: values.education.value,
      profession: values.profession.value
    };
    props
      .updateUserProfile(submittedValues, () => {
        props.redirectToLastViewedEssentialPage();
      })
      .then(() => {
        setSubmitting(false);
      });
  },
  displayName: FORM_NAME.USER_COMPLETE_PROFILE_FORM
});

class SignupProfileForm extends Component {
  async componentWillMount() {
    // TODO graphql query
    await this.props.fetchUserProfile();
    const { tagOptions } = this.props;
    if (!tagOptions.length) {
      this.props.fetchTags();
    }
  }

  handleUploadResume = (res) => {
    if (has(res, 'data.Location')) {
      const resumeUrl = res.data.Location;
      this.setState({ resumeUrl });
      // this.props.analyzeResumeScore(resumeUrl);
      HHAlert({ id: 'alert.success.uploadResumeSuccess' }, ALERT_TYPE.SUCCESS);
    }
  };

  render() {
    const {
      tagOptions, handleSubmit, isSubmitting, translate, values
    } = this.props;

    const educationOptions = [
      { value: 'High School', label: translate('form.label.highSchool') },
      { value: 'Diploma', label: translate('form.label.diploma') },
      { value: 'College', label: translate('form.label.college') },
      { value: 'University', label: translate('form.label.university') },
      { value: 'Master', label: translate('form.label.master') },
      { value: 'PhD', label: translate('form.label.PhD') },
      { value: 'Others', label: translate('common.others') }
    ];

    const professionOptions = [
      { value: 'Designer', label: translate('form.label.designer') },
      { value: 'Software Engineer', label: translate('form.label.softwareEngineer') },
      { value: 'Data Analysis', label: translate('form.label.dataAnalysis') },
      { value: 'AI', label: translate('form.label.AI') },
      { value: 'Businsess', label: translate('form.label.businsess') },
      { value: 'Human Resource', label: translate('form.label.humanResource') },
      { value: 'Finance', label: translate('form.label.finance') },
      { value: 'Marketing', label: translate('form.label.marketing') },
      { value: 'Health', label: translate('form.label.health') },
      { value: 'Others', label: translate('common.others') }
    ];

    return (
      <Form onSubmit={handleSubmit}>
        <Form.Field>
          <label htmlFor='tags'>{translate('yourTopSkills', { num: 5 })}</label>
          <Field
            name='tags'
            component={HHMultipleSelect}
            otherProps={{
              id: 'tags',
              options: tagOptions,
              creatable: true,
              placeholder: translate('tags hint')
            }}
          />
        </Form.Field>

        <Form.Field>
          <label htmlFor='education'>{translate('yourEducation')}</label>
          <Field
            name='education'
            component={HHSingleSelect}
            otherProps={{
              id: 'education',
              options: educationOptions,
              creatable: false,
              placeholder: translate('button.select')
            }}
          />
        </Form.Field>

        <Form.Field>
          <label htmlFor='profession'>{translate('yourProfession')}</label>
          <Field
            name='profession'
            component={HHSingleSelect}
            otherProps={{
              id: 'profession',
              options: professionOptions,
              creatable: false,
              placeholder: translate('button.select')
            }}
          />
        </Form.Field>

        <Form.Field className='completeProfile_resume'>
          <label htmlFor='resumeUrl'>{translate('yourResume')}</label>
          {values.resumeUrl && (
            <a href={values.resumeUrl} target='_blank' rel='noopener noreferrer'>
              {translate('download.resume')}
            </a>
          )}
          <Field
            name='resumeUrl'
            component={HHFileUploader}
            otherProps={{
              type: 'document',
              onUpload: this.handleUploadResume,
              trigger: (
                <Button
                  type='button' id='resumeUrl' basic
                  color='blue' floated='right'
                >
                  {translate('uploadResume')}
                </Button>
              )
            }}
          />
        </Form.Field>

        <Form.Field>
          <Field
            name='isJobSeeking'
            component={HHCheckbox}
            otherProps={{
              label: translate('LookingForJob'),
              toggle: true,
              id: 'isJobSeeking',
              className: 'inline'
            }}
          />
        </Form.Field>

        <Button
          fluid
          primary
          loading={isSubmitting}
          disabled={isSubmitting}
          className='g-rounded g-gradient text-uppercase'
          type='submit'
          size='big'
        >
          {translate('finish setup')}
        </Button>
      </Form>
    );
  }
}

export default compose(
  withLocalize,
  withRouter,
  connect(
    ({ tags }) => ({ tagOptions: tags.tagOptions || [] }),
    {
      analyzeResumeScore,
      fetchTags,
      fetchUserProfile,
      updateUserProfile,
      redirectToLastViewedEssentialPage,
      sendNewSignUpEmail
    }
  ),
  formikEnhancer
)(SignupProfileForm);



// WEBPACK FOOTER //
// ./src/components/forms/signupProfileForm.js